export const AVAILABILITY_MAX_ATTEMPTS = 3;
